import { useSubsidiaryProducts } from '~/features/platform/hooks/use-subsidiary-products';
import { useAuthStore } from '~/store/auth.store';

/**
 * Returns the enrolled products for the current subsidiary.
 * Reads `activeTenantId` from auth store so callers don't need to know the
 * subsidiary ID. trial-flow is shipped, so products are always fetched for
 * authenticated users.
 */
export function useEnrolledProducts() {
  const subsidiaryId = useAuthStore((s) => s.user?.activeTenantId);
  return useSubsidiaryProducts(subsidiaryId);
}
